import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { ROUTE_STRINGS } from 'Utils/Constants'
import Button from 'Components/UIComponent/Button'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import CoffeeWebQuiz from './Pages/CoffeeWebQuiz'
import CoffeeSnake from './Pages/CoffeeSnake'

const CoffeeGames = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const userDetails = getLocalUserDetails()
  const { setLoading } = useContext(CoffeeWebContext)

  const [gamesList, setGamesList] = useState([])
  const [selectedGames, setSelectedGames] = useState(gamesList[0])
  const [showInfo, setShowInfo] = useState(false)

  useEffect(() => {
    fetchCoffeeGamesList()
  }, [])

  const fetchCoffeeGamesList = async () => {
    setLoading(true)
    try {
      const response = await apiAdapterCoffeeWeb.getCoffeeGamesList()

      const responseData = response?.data

      setGamesList(responseData)

      setSelectedGames(responseData[0])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleDropDownChange = (value) => {
    setSelectedGames(value)
    setShowInfo(false)
  }

  const handleOpenModal = () => {
    if (!userDetails) {
      history.push({ pathname: ROUTE_STRINGS.login, state: { coffeeQuiz: true } })
    }

    setShowInfo(true)
  }

  const GameControls = () => (
    <div className="quiz-controls-wrapper">
      <div className="quiz-selector-container">
        <Dropdown value={selectedGames} onChange={(e) => handleDropDownChange(e.value)} options={gamesList} optionLabel="name" placeholder={t('CHOOSE_GAME')} panelClassName="quiz-selector-panel" className="quiz-selector" appendTo="self" />
      </div>
      <div className="info-button-wrapper">
        <Button buttonType="CUSTOM" buttonLabel={t('INSTRUCTIONS')} variant="hard-action" onButtonClick={handleOpenModal} />
      </div>
    </div>
  )

  return (
    <div className="coffee-games-wrapper">
      {(!userDetails || userDetails?.isCoffeeGamesAvailable) && (
        <div className="page-header">
          <div className="page-title">{t('COFFEE_GAMES')}</div>
        </div>
      )}

      {selectedGames?.gameId === 'GAMES001' && <CoffeeWebQuiz GameControls={GameControls} showInfo={showInfo} setShowInfo={setShowInfo} selectedGames={selectedGames} />}
      {selectedGames?.gameId === 'GAMES002' && <CoffeeSnake GameControls={GameControls} showInfo={showInfo} setShowInfo={setShowInfo} />}
    </div>
  )
}

export default CoffeeGames
